import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Travel1 from '../views/travel1.vue'
import Travel2 from '../views/travel2.vue'
import Post from '../views/_slug.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/travel1',
    name: 'travel1',
    component: Travel1
  },
  {
    path: '/travel2',
    name: 'travel2',
    component: Travel2
  },
  {
    path: '/:slug',
    name: 'post',
    component: Post
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
